(function () {
    'use strict';

    a3_cabin_reports.directive('annualLeavesSummary', annualLeavesSummary);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name annualLeavesSummary
    * @restrict E
    * @description
    *    Display a summary of Annual Leaves read from localStorage.
    *    Consecutive dates with the same Type are grouped into a single date-range row.
    *    Data shape from storage: { Date, Type, DutyDescription }
    * @example
    *   Usage:
    *   <annual-leaves-summary></annual-leaves-summary>
    * @ngInject
    */
    function annualLeavesSummary(AnnualLeavesFactory) {
        function link($scope) {
            $scope.showAnnualLeavesSummary = false;
            $scope.isPanelOpen = true;
            $scope.togglePanel = function () { $scope.isPanelOpen = !$scope.isPanelOpen; };

            var typeColorMap = {
                'ALV': 'leave-badge-blue',
                'RLV': 'leave-badge-orange',
                'OLV': 'leave-badge-green',
                'WLV': 'leave-badge-red'
            };
            $scope.getTypeBadgeClass = function (type) {
                return typeColorMap[type] || 'leave-badge-gray';
            };

            var annualLeavesInfo = AnnualLeavesFactory.getAnnualLeavesToStorage();
            if (annualLeavesInfo && annualLeavesInfo.length > 0) {
                $scope.showAnnualLeavesSummary = true;
                $scope.annualLeaves = groupAnnualLeaves(annualLeavesInfo);
            }

            function groupAnnualLeaves(leaves) {
                var grouped = [];
                leaves = leaves.slice().sort(function (a, b) {
                    return new Date(a.Date) - new Date(b.Date);
                });

                for (var i = 0; i < leaves.length; i++) {
                    var prev = grouped[grouped.length - 1];
                    if (
                        i !== 0 &&
                        prev.type === leaves[i].Type &&
                        (new Date(leaves[i].Date) - new Date(prev.dateTo) === 86400000)
                    ) {
                        prev.dateTo = leaves[i].Date;
                        prev.DutyCounter++;
                    } else {
                        grouped.push({
                            type: leaves[i].Type,
                            description: leaves[i].DutyDescription,
                            dateFrom: leaves[i].Date,
                            dateTo: leaves[i].Date,
                            DutyCounter: 1
                        });
                    }
                }
                return grouped;
            }
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/LeaveRequest/annual-leaves-summary.tpl.html',
            scope: true,
            link: link
        };
    }

})();
